import React, { useState, useRef, useEffect } from 'react';
import Tab from './Tab';
import AddTabButton from './AddTabButton';

const TabNavigation = ({
  tabs,
  selectedTab,
  onTabChange,
  onTabDelete,
  onTabNameUpdate,
  onAddTabClick
}) => {
  const [hoveredTab, setHoveredTab] = useState(null);
  const [editingTabId, setEditingTabId] = useState(null);
  const [editingTabName, setEditingTabName] = useState('');
  const editTabInputRef = useRef(null);

  useEffect(() => {
    if (editingTabId && editTabInputRef.current) {
      editTabInputRef.current.focus();
      editTabInputRef.current.select();
    }
  }, [editingTabId]);

  const handleTabDoubleClick = (tab) => {
    setEditingTabId(tab.tab_id);
    setEditingTabName(tab.tab_name);
  };

  const handleTabNameSave = async () => {
    if (!editingTabId || !editingTabName.trim()) {
      setEditingTabId(null);
      return;
    }

    try {
      await onTabNameUpdate(editingTabId, editingTabName);
    } catch (err) {
      console.error("Error updating tab name:", err);
    } finally {
      setEditingTabId(null);
    }
  };

  const handleTabNameKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleTabNameSave();
    } else if (e.key === 'Escape') {
      setEditingTabId(null);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (editingTabId && editTabInputRef.current && !editTabInputRef.current.contains(event.target)) {
        handleTabNameSave();
      }
    };

    if (editingTabId) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [editingTabId, editingTabName]);

  return (
    <div className="flex items-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {tabs.map(tab => (
        <Tab
          key={tab.tab_id}
          tab={tab}
          isSelected={selectedTab === tab.tab_id}
          isEditing={editingTabId === tab.tab_id}
          editingTabName={editingTabName}
          setEditingTabName={setEditingTabName}
          onTabClick={onTabChange}
          onTabDoubleClick={handleTabDoubleClick}
          onTabNameSave={handleTabNameSave}
          onTabNameKeyDown={handleTabNameKeyDown}
          onDeleteTab={onTabDelete}
          isHovered={hoveredTab === tab.tab_id}
          onMouseEnter={() => setHoveredTab(tab.tab_id)}
          onMouseLeave={() => setHoveredTab(null)}
        />
      ))}
      <AddTabButton onClick={onAddTabClick} />
    </div>
  );
};

export default TabNavigation;
